export const GET_PAST_VISIT_INFO = 'pastVisit/GET_PAST_VISIT_INFO'
export const GET_PAST_VISIT_INFO_ERROR = 'pastVisit/GET_PAST_VISIT_INFO_ERROR'
export const GET_PAST_VISIT_INFO_SUCCESS = 'pastVisit/GET_PAST_VISIT_INFO_SUCCESS'

export const GET_PAST_VISIT_PRESCRIPTION = 'pastVisit/GET_PAST_VISIT_PRESCRIPTION'
export const GET_PAST_VISIT_PRESCRIPTION_SUCCESS = 'pastVisit/GET_PAST_VISIT_PRESCRIPTION_SUCCESS'
export const GET_PAST_VISIT_PRESCRIPTION_ERROR = 'pastVisit/GET_PAST_VISIT_PRESCRIPTION_ERROR'

export const SET_PAST_VISIT_ERROR = 'pastVisit/SET_PAST_VISIT_ERROR'
export const GET_PROVIDER_INFO_VISIT_INFO = 'pastVisit/GET_PROVIDER_INFO_VISIT_INFO'
export const GET_PROVIDER_INFO_VISIT_INFO_SUCCESS = 'pastVisit/GET_PROVIDER_INFO_VISIT_INFO_SUCCESS'
export const GET_PROVIDER_INFO_VISIT_INFO_ERROR = 'pastVisit/GET_PROVIDER_INFO_VISIT_INFO_ERROR'
